import { render, staticRenderFns } from "./PostDetail.vue?vue&type=template&id=0dcf96dc&scoped=true"
import script from "./PostDetail.vue?vue&type=script&lang=js"
export * from "./PostDetail.vue?vue&type=script&lang=js"
import style0 from "./PostDetail.vue?vue&type=style&index=0&id=0dcf96dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcf96dc",
  null
  
)

export default component.exports